/** When your routing table is too long, you can split it into small modules**/

export default [
  {
    path: "/khorooj-request",
    name: "khoroojRequest",
    component: () => import("@/views/khorooj/Request"),
  },
  {
    path: "/khorooj-history",
    name: "khoroojHistory",
    component: () => import("@/views/khorooj/History"),
  },
  {
    path: "/khorooj-last",
    name: "khoroojLast",
    component: () => import("@/views/khorooj/Last"),
  },
  {
    path: "/khorooj-index",
    name: "khoroojIndex",
    component: () => import("@/views/khorooj/Index"),
  },
  {
    path: "/amrieh",
    name: "Amrieh",
    component: () => import("@/views/khorooj/Amrieh"),
  },
];
